module.exports = __webpack_public_path__ + "img/shushiqu.66a22776.png";